import axios from 'axios';
import { Company, CompanyDto, CompanyMapper } from '../models/company.model';
import appConfig from '../appConfig';
import { Option } from '../models/components.model';
import { Category } from '../models/category.model';
import { AppStorage } from '../storage/app-storage';

export class CompanyService {
  static companyList: Company[] = AppStorage.getCompanyList();

  static async fetchCompanyOptions(): Promise<Option[]> {
    try {
      const response = await axios.get(`${appConfig.BASE_URL}/company`);
      const companies = response?.data?.results?.map((el: CompanyDto) => ({
        value: el.domain,
        label: el.name,
      }));
      return companies;
    } catch (error) {
      // Handle the error, e.g., logging it or returning an empty array
      console.error("Error fetching companies:", error);
      return [];
    }
  }

  static async fetchCompanies(
    category?: Category,
    geoCoords?: string
  ): Promise<Company[]> {
    let params: { verticalName?: string; geoCoords?: string } = {};
    if (category) {
      params.verticalName = category?.key;
    }
    if (geoCoords) {
      params.geoCoords = geoCoords;
    }
    if (!category && this.companyList?.length) {
      return this.companyList;
    }

    try {
      const response = await axios.get(`${appConfig.BASE_URL}/company/v2`, {
        params,
      });
      const companies = (response?.data?.data as CompanyDto[])?.map((dto) =>
        CompanyMapper.fromCompanyDto(dto)
      );
      if (!category) {
        AppStorage.saveCompanyList(companies);
      }
      return companies;
    } catch (error) {
      console.error("Error fetching companies:", error);
      return [];
    }
  }
  static urlCompanyImage = (url: string | undefined) =>
    url ? `${appConfig.BASE_URL}/photos/company/${url}` : "";

  static companyLogo = (url: string) => this.urlCompanyImage(url);

  static setSelectedCategory = (option: Option, options: Option[]) => {
    return options?.map(opt => {
      if (opt.label === option?.label) {
        return {...option};
      }
      return opt;
    })
  }

  static setSuggestions = (companies: Company[], selectedCategory: Category | undefined) => {
    return companies?.map(c => {
      return {
        value: c?.name, label: c?.name, isDisabled: c.name === selectedCategory?.name
      };
    })?.filter(c => !c.isDisabled);
  }

  static filterCompanies(companies: Company[], options: Option[]) {
    return companies.filter((company: Company) => {
      const companyName = company?.name?.toLowerCase();
      return options?.some(
        (option) => companyName?.includes(option?.label?.toLowerCase())
      );
    });
  }
}
